import { useEffect, useRef, useState } from 'react';

import {
  isSameFloatingNotch,
  measureFloatingNotch,
  setNotchReveal,
  subscribeFloatingNotchMeasure,
} from '../utils';

export const useFloatingNotch = (enabled, dependencyKey) => {
  const tabBarRef = useRef(null);
  const [notch, setNotch] = useState(null);

  useEffect(() => {
    const tabBar = tabBarRef.current;

    if (!tabBar || !enabled) {
      setNotch(null);
      setNotchReveal(false);

      return undefined;
    }

    setNotchReveal(true);

    const measure = () => {
      const next = measureFloatingNotch(tabBar);

      setNotch(prev => {
        if (!next) {
          return null;
        }

        return isSameFloatingNotch(prev, next) ? prev : next;
      });
    };

    const unsubscribe = subscribeFloatingNotchMeasure(tabBar, measure);

    return () => {
      unsubscribe();
      setNotchReveal(false);
    };
  }, [enabled, dependencyKey]);

  return { notch, tabBarRef };
};

export default useFloatingNotch;
